// src/pages/info/DBCollectors.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaPlus } from 'react-icons/fa';
import DBCollectorsTable from '../../../components/Directory/DBCollectorsTable';
import '../../CheckPage/CheckPage.css';
import AddCollectorModal from '../../../components/Modals/AddCollectorModal';


const DBCollectors = () => {
  const [query, setQuery] = useState(() => localStorage.getItem('collectorQuery') || '');
  const [selectedCollectorId, setSelectedCollectorId] = useState(() => localStorage.getItem('selectedCollectorId') || null);
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);          // открыть / закрыть

  

  useEffect(() => {
  localStorage.setItem('collectorQuery', query);
}, [query]);

useEffect(() => {
  if (selectedCollectorId !== null) {
    localStorage.setItem('selectedCollectorId', selectedCollectorId);
  }
}, [selectedCollectorId]);

  const handleSearch = () => {
    console.log('Поиск:', query);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="check-page">
      <h1 className="page-title">База данных коллекторов в г. Норильск</h1>

      <div className="toolbar">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Поиск по коллекторам г. Норильска"
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <button
            type="button"
            className="search-btn"
            onClick={handleSearch}
            title="Искать"
          >
            <FaSearch />
          </button>
        </div>

        <button
          className="primary-btn"
          onClick={() => setShowAddModal(true)}
        >
          <FaPlus style={{ marginRight: 6 }} />
          Новый коллектор
        </button>

      </div>

      <div className="table-area">
        <DBCollectorsTable
          query={query}
          selectedRowId={selectedCollectorId}
          onRowSelect={row => {
            setSelectedCollectorId(row.id);
            navigate(`/collectors/${row.id}`, { state: { ...row, source: 'db' } });
          }}
        />
      </div>

      {showAddModal && (
        <AddCollectorModal
          onClose={() => setShowAddModal(false)}
          onAdded={(newId) => {
            // сразу подсветим только-что созданный коллектор,
            // а при желании можно плюсиком дернуть refetch таблицы
            setSelectedCollectorId(newId);
          }}
        />
      )}

    </div>
  );
};

export default DBCollectors;
